import { FrameScheduleSearchResponse } from 'src/types/apiModels';

export const areDisplayUnitIdsUnique = (fetchedDataForOpeningHoursSearchRequest: FrameScheduleSearchResponse | undefined) => {
  return fetchedDataForOpeningHoursSearchRequest ? fetchedDataForOpeningHoursSearchRequest.length > 1 : false;
};
